import { useContext, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerModalCentro,
  ContainerP5,
} from "./localStyle";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import { FaMapMarkerAlt } from "react-icons/fa";
import InformacionIcon from "_+_Portal/assets/images/generico/InformacionIcon";

const OtroCentro = () => {
  // -------------------------  useContex  ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { ordenDigitalDispatch } = useContext(PortalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    sessionStorage.removeItem("otroCentro");
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    setPaso("Home")(pasoDispatch);
  };

  const handleComoLlegar = () => {
    const coordenadaGps = JSON.parse(sessionStorage.getItem("otroCentro"));
    const url = `https://www.google.com/maps/dir/?api=1&destination=${coordenadaGps}&dir_action=navigate&travelmode=walking`;
    window.open(url, "_blank");
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"Turno en otra sede"}
        subtitle={""}
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5>
              <div className="ptur-turnoNoEncontrado-noEcontrados-icono">
                <InformacionIcon />
              </div>
              <ContainerModalCentro>
                {/* <span className="bold">¿Desea tomar el turno como particular?</span> */}
                <p>
                  Estás en una sede diferente a la del turno. Para poder
                  recepcionarte, seguí estos pasos:
                </p>
                <p>
                  1) Tocá "¿Cómo llegar?" para ver la ubicación.
                  <br />
                  2) Cuando llegues, escaneá el código QR para comenzar la
                  recepción.
                </p>
                <span
                  className="bold btn-como-llegar"
                  onClick={handleComoLlegar}
                >
                  <FaMapMarkerAlt color={"var(--color-latex30)"} size={20} />{" "}
                  ¿Cómo llegar?
                </span>
              </ContainerModalCentro>
              <ButtonP5 onClick={() => volver()}>Cerrar</ButtonP5>
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default OtroCentro;
